export var ToolActionKind;
(function (ToolActionKind) {
    ToolActionKind["ApplyDiscount"] = "apply-discount";
    ToolActionKind["Dismiss"] = "dismiss";
    ToolActionKind["Hide"] = "hide";
    ToolActionKind["EmptyClick"] = "empty-click";
    ToolActionKind["Fallback"] = "none";
    ToolActionKind["GenericLinkClick"] = "generic-link-click";
    ToolActionKind["LoadScript"] = "load-script";
    ToolActionKind["OpenBookingEngine"] = "open-be";
    ToolActionKind["OpenUri"] = "open-uri";
    ToolActionKind["PredictiveAudience"] = "predictive-audience";
    ToolActionKind["SendForm"] = "send-form";
    ToolActionKind["SendSaveSearch"] = "send-save-search";
    ToolActionKind["SendSiteContact"] = "send-site-contact";
    ToolActionKind["SendSubscribe"] = "send-subscribe";
    ToolActionKind["Show"] = "show";
    ToolActionKind["Login"] = "login";
    ToolActionKind["LastSearch"] = "send-to-last-search";
    ToolActionKind["TranslateDocumentBody"] = "translate-document-body";
})(ToolActionKind || (ToolActionKind = {}));
export var FormDataLoginAction;
(function (FormDataLoginAction) {
    FormDataLoginAction["Resend"] = "resend";
    FormDataLoginAction["Signup"] = "signup";
    FormDataLoginAction["Signin"] = "signin";
    FormDataLoginAction["Validation"] = "validation";
})(FormDataLoginAction || (FormDataLoginAction = {}));
//# sourceMappingURL=tool-actions.types.js.map